var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg01Happy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 59.9999C46.5685 59.9999 59.9999 46.5685 59.9999 29.9999C59.9999 13.4314 46.5685 0 29.9999 0C13.4314 0 0 13.4314 0 29.9999C0 46.5685 13.4314 59.9999 29.9999 59.9999Z",
    fill: "#FDDF6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.4286 55.5712C19.8601 55.5712 6.42875 42.1398 6.42875 25.5714C6.42875 16.7194 10.2633 8.76421 16.3612 3.27295C6.64894 8.23886 0 18.3429 0 30.0001C0 46.5686 13.4314 59.9999 29.9998 59.9999C37.7165 59.9999 44.7517 57.0855 50.0672 52.2986C45.9753 54.3908 41.34 55.5712 36.4286 55.5712Z",
    fill: "#9D4F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8078 24.3743C26.8298 24.3743 28.469 22.7351 28.469 20.713C28.469 18.691 26.8298 17.0518 24.8078 17.0518C22.7857 17.0518 21.1465 18.691 21.1465 20.713C21.1465 22.7351 22.7857 24.3743 24.8078 24.3743Z",
    fill: "#9D4F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.421 24.3743C47.4431 24.3743 49.0823 22.7351 49.0823 20.713C49.0823 18.691 47.4431 17.0518 45.421 17.0518C43.399 17.0518 41.7598 18.691 41.7598 20.713C41.7598 22.7351 43.399 24.3743 45.421 24.3743Z",
    fill: "#9D4F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6146 46.3552C32.3818 46.3552 29.3952 44.599 27.8205 41.7723C27.4925 41.1834 27.7038 40.4402 28.2928 40.1122C28.8814 39.7838 29.6249 39.9955 29.9527 40.5845C31.0968 42.6384 33.2664 43.9143 35.6146 43.9143C37.9031 43.9143 40.0973 42.6255 41.341 40.5508C41.6877 39.9729 42.4368 39.7849 43.0152 40.1316C43.5934 40.4783 43.781 41.2278 43.4344 41.8059C41.752 44.612 38.7558 46.3552 35.6146 46.3552Z",
    fill: "#9D4F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01Happy);
export default __webpack_public_path__ + "static/media/01-Happy.0277e14bd30fb25b00713558771eefd8.svg";
export { ForwardRef as ReactComponent };